import React,{ useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';

import metadata from './MLClaimPaymentsComponent.metadata.json5';
import styles from './MLClaimPaymentsComponent.module.scss';
import messages from './MLClaimPaymentsComponent.messages';

import { IntlContext } from '@jutro/legacy/locale';

const MLClaimPaymentsComponent = (props) => {
    const {
        payments,
    } = props;
    const translator = useTranslator();
    const intl = useContext(IntlContext);

    const getCurrencyFromAmounts = (claimPayments)  => {
        if(claimPayments && claimPayments.length) {
            // Grab first payment and return that currency
            return payments[0].amountPaid.currency;
        }
        // Else default to usd
        return 'usd';
    }

    const totalPaid = {amount: payments.reduce((tot, payment) => tot + payment.amountPaid.amount, 0), currency: getCurrencyFromAmounts(payments)};

    const formatAmountString = (amount) => {
        try {
            return intl.formatNumber(amount.amount, { style: 'currency', currency: amount.currency });
        } catch (e) {
            return '';
        }
    };

    const formatPayeeString = (payees) => {
        let payeeString = '';
        for(let i = 0; i < payees.length; i++){
            const formattedPayeename = _.startCase(_.lowerCase(payees[i]));
            payeeString += formattedPayeename;
            if(i > 0 && i < payees.length - 2){
                payeeString += ', '
            } else if(i !== payees.length -1){
                payeeString += ' and ';
            }
        }

        return payeeString;
    }

    const formatPaymentTableData = () => {
        let key = 0;
        return payments.map((payment) => {
            const formattedPayment = {
                key : key++,
                paymentDate : intl.formatDate(payment.date, { year: 'numeric', month: 'numeric', day: 'numeric'}),
                coverageType: payment.coverageName_ML,
                payeeString: formatPayeeString(payment.payee),
                amountPaid:  formatAmountString(payment.amountPaid)
            };
            return formattedPayment
        })
    }

    const overrideProps = {
        [`paymentsTable`] : {
            data: formatPaymentTableData()
        },

        totalPaidSpan: {
            content: (
                <div>
                    <span><strong>{translator(messages.total)}</strong></span> &nbsp;&nbsp;
                    <span style={{fontSize: '26px', marginLeft: '25px'}}><strong>{formatAmountString(totalPaid)}</strong></span>
                </div>
            )

        },
    };
    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLClaimPaymentsComponent.propTypes = {
    payments: PropTypes.arrayOf(PropTypes.object).isRequired,
    policyType: PropTypes.string.isRequired
};

export default MLClaimPaymentsComponent;
